// Needs to have the same name as the Feature enum in CLB!

export enum FeatureSwitch {
  FEATURE_FOR_UNIT_TESTS = 'FEATURE_FOR_UNIT_TESTS',
  PPA_13285_RENT_SALE_MOBILE_NEW_IMAGE_UPLOAD = 'PPA_13285_RENT_SALE_MOBILE_NEW_IMAGE_UPLOAD',
}

export const FeatureSwitchesDefaultValues: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_13285_RENT_SALE_MOBILE_NEW_IMAGE_UPLOAD]: false,
}

export const ALL_FEATURES_ENABLED: FeatureSwitchMap = {
  [FeatureSwitch.FEATURE_FOR_UNIT_TESTS]: true,
  [FeatureSwitch.PPA_13285_RENT_SALE_MOBILE_NEW_IMAGE_UPLOAD]: true,
}

export type FeatureSwitchMap = Partial<Record<FeatureSwitch, boolean>>
